import { render, staticRenderFns } from "./originalEdit.vue?vue&type=template&id=b56c153c&scoped=true&"
import script from "./originalEdit.vue?vue&type=script&lang=js&"
export * from "./originalEdit.vue?vue&type=script&lang=js&"
import style0 from "./originalEdit.vue?vue&type=style&index=0&id=b56c153c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c153c",
  null
  
)

export default component.exports